import { Badge, Button, Group, Loader, Stack, Text } from "@mantine/core";
import { ICapitalLetter } from "@schemas/otherAttributesSchema";
import { useMemo } from "react";
import { useGetProjectByProjectIdIssueFormulaGroupIssuesQuery } from "../../../../../../../../openapi";
import { useAppSelector } from "../../../../../../../hooks";
import { selectCurrentOpenIssueBoardInModal, selectCurrentOpenIssueInModal } from "../../../../issueSelectors";
import { selectFormulaCounterGroupIssuesBaseArgsInModal } from "./issueFormulaCounterSuggestion.selectors";
import { formatCounter, getFormulaCounterSuggestions } from "./issueFormulaCounterSuggestion.utils";

const IssueFormulaCounterSuggestions = ({
  formulaAttributeKey,
  isActive,
  onSelectSuggestion,
}: {
  formulaAttributeKey: ICapitalLetter;
  isActive: boolean;
  onSelectSuggestion: (value: number) => void;
}) => {
  const issue = useAppSelector(selectCurrentOpenIssueInModal);
  const issueBoard = useAppSelector(selectCurrentOpenIssueBoardInModal);
  const baseArgs = useAppSelector(selectFormulaCounterGroupIssuesBaseArgsInModal);
  const formula = issueBoard?.otherAttributesConfig?.[formulaAttributeKey]?.formula;

  const { data, isFetching } = useGetProjectByProjectIdIssueFormulaGroupIssuesQuery(
    {
      projectId: baseArgs?.projectId ?? "",
      issueId: issue?._id ?? "",
      formulaAttributeKey,
    },
    {
      skip: !isActive || issue == null || baseArgs == null || formula == null,
    },
  );

  const suggestions = useMemo(
    () => getFormulaCounterSuggestions(data, formulaAttributeKey),
    [data, formulaAttributeKey],
  );
  const minLength = formula?.nrOfCharsInCounter ?? 3;

  return (
    <Stack gap="xs">
      <Group justify="space-between" gap="xs">
        <Text size="sm" fw={600}>
          Forslag
        </Text>
        {isFetching && <Loader size="xs" color="orange" />}
      </Group>
      <Text size="sm" c="dimmed">
        Basert på løpnummer i samme formelgruppe.
      </Text>
      <Group gap="xs">
        {suggestions.map((suggestion) => (
          <Button
            key={suggestion}
            size="xs"
            color="orange"
            variant="light"
            onMouseDown={(event) => event.preventDefault()}
            onClick={() => onSelectSuggestion(suggestion)}
          >
            {formatCounter(suggestion, minLength)}
          </Button>
        ))}
        {suggestions.length > 1 && (
          <Badge color="gray" variant="light">
            {suggestions.length} forslag
          </Badge>
        )}
      </Group>
    </Stack>
  );
};

export default IssueFormulaCounterSuggestions;
